import './src/index'
import { withPrefix } from 'gatsby'
import getUserLang from './locales/getUserLang'
import languages from './locales'

export const onClientEntry = () => {
  const userLang = getUserLang()

  if (userLang && window.location.pathname === '/') {
    const url = userLang || languages.defaultLangKey

    window.location.pathname = withPrefix(url)
  }
}

export default {
  onClientEntry
}
